import { Component, OnInit, ViewChild } from "@angular/core";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-client-statements",
  templateUrl: "./client-statements.component.html",
  styleUrls: ["./client-statements.component.css"],
})
export class ClientStatementsComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  filter_collapsed = true;
  clients_raw_data;
  filterActive = false;
  is_refreshing = false;
  clients: any;
  filterForm: FormGroup;

  constructor(
    private leadService: LeadsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForms();
  }

  ngOnInit() {
    // this.getClientStatements();
    if (
      ["keyword", "date_from", "date_to", "unit_serial"].some(
        (f) => this.route.snapshot.queryParams[f]
      )
    ) {
      this.filterClients(false);
    } else {
      this.getClientStatements();
    }
  }

  createForms() {
    this.filterForm = this.fb.group({
      status: ["Closed"],
      with_finance: [1],
      keyword: [this.route.snapshot.queryParams.keyword || ""],
      date_from: [this.route.snapshot.queryParams.date_from || ""],
      date_to: [this.route.snapshot.queryParams.date_to || ""],
      unit_serial: [this.route.snapshot.queryParams.date_to || ""],
    });
  }

  getClientStatements() {
    const { status } = this.filterForm.value;
    this.leadService.getLeads({ status }).subscribe((res: any) => {
      console.log(res);
      this.clients_raw_data = res;
      this.clients = res.data;
    });
  }

  viewClient(client) {
    this.router.navigate(["/pages/clients-statements", client.id]);
  }

  getNewRecord(event) {
    this.clients = event.data;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.createForms();
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }

  filterClients(cache = true) {
    let formModel = this.filterForm.value;
    console.log(formModel);
    if (cache) this.setQueryParams(formModel);
    this.leadService.getLeads(formModel).subscribe((res: any) => {
      this.clients_raw_data = res;
      this.clients = res.data;
    });
  }

  // cache filters
  setQueryParams(params = {}) {
    let data: any = {};

    ["keyword", "date_from", "date_to", "unit_serial"].map((f) => {
      if (params[f]) {
        data[f] = params[f];
      }
    });
    console.log(data);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: data,
      replaceUrl: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/client-statements/client-statements.component.ts